// Sessão do desktop no cofre do sistema (Segurança, item 6): Keychain no Mac,
// Gerenciador de Credenciais no Windows — via comandos Rust (src-tauri/src/lib.rs, crate keyring).
// Nunca em arquivo de texto nem em localStorage.

export type Invoke = <T>(cmd: string, args?: Record<string, unknown>) => Promise<T>;

export interface AsyncStorage {
  getItem(key: string): Promise<string | null>;
  setItem(key: string, value: string): Promise<void>;
  removeItem(key: string): Promise<void>;
}

export function createSecureStorage(invoke: Invoke): AsyncStorage {
  return {
    getItem: (key) => invoke<string | null>('secure_get', { key }),
    setItem: (key, value) => invoke<void>('secure_set', { key, value }),
    removeItem: (key) => invoke<void>('secure_delete', { key }),
  };
}
